import BaseDialog from '../../ui/BaseDialog';
import { BroadcastOnPersonal, QueuePlayNext } from '@mui/icons-material';
import { Box, Chip, CircularProgress, FormControlLabel, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRegistrationMode } from '@/hooks/registration/useRegistrationMode';

const RegistrationMode = () => {
    const { t } = useTranslation('common');

    const {
        state,
        isLoading,
        isInstallationMode,
        confirmMessage,
        openConfirmDialog,
        closeConfirmDialog,
        confirmModeChange,
    } = useRegistrationMode();

    if (isLoading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '200px',
                    height: '38px',
                    mr: 4,
                }}
            >
                <CircularProgress size={32} />
            </Box>
        );
    }

    return (
        <>
            <FormControlLabel
                sx={{ mr: 4 }}
                control={<Switch color="secondary" checked={isInstallationMode} onChange={openConfirmDialog} />}
                label={
                    isInstallationMode ? (
                        <Chip
                            sx={{ pl: 1 }}
                            icon={<QueuePlayNext />}
                            color="secondary"
                            label={t('Installation mode')}
                        />
                    ) : (
                        <Chip
                            sx={{ pl: 0.7 }}
                            icon={<BroadcastOnPersonal />}
                            color="secondary"
                            label={t('Normal mode')}
                        />
                    )
                }
            />

            <BaseDialog
                open={state.dialogState.isStoreStateOpen}
                dialogTitle={t('Store Status Change')}
                confirmButtonText={t('Confirm')}
                cancelButtonText={t('Cancel')}
                onConfirm={confirmModeChange}
                onClose={closeConfirmDialog}
            >
                <Box>
                    <Typography>{confirmMessage}</Typography>
                </Box>
            </BaseDialog>
        </>
    );
};

export default RegistrationMode;
